import type { RouteRecordName } from 'vue-router'
import { useRouter } from 'vue-router'
import { computed } from 'vue'

export function useIsOnRoute(routes: RouteRecordName[]) {
    const router = useRouter()

    return computed(
        () =>
            router.currentRoute.value.name &&
            routes.includes(router.currentRoute.value.name)
    )
}
